// extracted by mini-css-extract-plugin
module.exports = {"description":"bundleDescription_description__GXGZ0","descriptionInner":"bundleDescription_descriptionInner__29qnl"};